import { Component, Inject } from '@angular/core';
import {Observable} from "rxjs";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Radar, RadarTrafficData} from 'src/app/device/shared/interfaces/radar.interface';
import { DeviceService } from 'src/app/device/shared/services/device.service';
import { TrafficAnalysisData } from 'src/app/project/shared/interfaces/mqresult.interface';
import { EngineTriggerTypeEnum, getEngineTriggerString } from "src/app/project/shared/enums/engine-trigger-type.enum" 



class RadarChartData {
    public trafficData?: RadarTrafficData;
    public trigger?: string; 
    public Z?: number;
    public VS?:number;
    public trafficAnalysisData?: TrafficAnalysisData;
    constructor(private tD?: RadarTrafficData, private tAD?: TrafficAnalysisData, 
      private t?:string, private z?:number, private vs?:number){
      this.trafficData= tD;
      this.trigger = t;
      this.Z = z;
      this.VS = vs;
      this.trafficAnalysisData = tAD;
    }
}

@Component({
  selector: 'avs-radar-data-chart',
  templateUrl: './radar-data-chart.component.html',
  styleUrls: ['./radar-data-chart.component.css']
})

export class RadarDataChartComponent{

  public radarData: RadarChartData[] = [];
  
  constructor(@Inject(MAT_DIALOG_DATA) public data: { radar$: Observable<Radar[]> }, private deviceService: DeviceService,
    private dialogRef: MatDialogRef<RadarDataChartComponent>) {

      this.data.radar$.subscribe(radars => {
        this.radarData = [];
        radars.forEach(r => {
          try
          {
            let trafficData: RadarTrafficData = r as RadarTrafficData;

            let trafficContent: TrafficAnalysisData|undefined;
            if (r.result.data) {
              trafficContent = JSON.parse(r.result.data);
            }

            let triggerType = r.result.triggerType;
            let z = r.result.z;
            let vs = r.result.vs;

            let newChartData: RadarChartData = new RadarChartData(trafficData, trafficContent, getEngineTriggerString(triggerType), z, vs);
            this.radarData = this.radarData.concat(newChartData);

          }
          catch(error){
            console.log("(radar-data-chart) channel "+r.de+": Cannot read traffic data from radar.result.data. Ignoring")
          }
        });
      });
  }

  public getZName(z:number|undefined): string
  {
    switch(z) {
      case 1: return z?.toString()+": Freier Verkehr";
      case 2: return z?.toString()+": Dichter Verkehr";
      case 3: return z?.toString()+": Zähfließender Verkehr";
      case 4: return z?.toString()+": Stau";
      default: return z?.toString() ?? "";
    }
  }

   public onCloseAddTimeSwitchClicked(): void {
    this.dialogRef.close();
  }
}
